import axios from "axios"
import { post, del, get, put } from "./api_helper"
import * as url from "./url_helper"
import { toast } from "react-toastify";

// Create course
export const createUserType = data => post(url.CREATE_USER_TYPE, data);
export const updateUserType = data => put(url.UPDATE_USER_TYPE, data);
export const deleteUserType = id => del(url.DELETE_USER_TYPE + id);
export const getAllUserTypes = () => get(url.FETCH_ALL_USER_TYPES);
export const getSingleUserType = () => get(url.GET_SINGLE_USER_TYPE);



